import { Box, Typography } from '@mui/material';

import { calculateSecondsToHoursAndMinutes, formatTime } from '@libs/dateTime';
import { statusLabel } from '../statusTokens';

/**
 * Tooltip body for one resolved day (output of buildMonthDaySheet):
 * date, status (with leave type / holiday name), in-out, duration, plus any
 * other statuses that share the day (e.g. worked on a holiday).
 */
const DayTooltipContent = ({ day }) => {
    const {
        date,
        status,
        leaveType,
        label,
        inTime,
        outTime,
        duration,
        extras = [],
        isFromRemote
    } = day || {};

    let statusText = statusLabel(status);
    if (status === 'leave' && leaveType) statusText += ` · ${leaveType}`;
    if (status === 'holiday' && label) statusText += ` · ${label}`;
    if (isFromRemote && status !== 'remote') statusText += ' · Remote';

    return (
        <Box>
            <Typography variant='body2' sx={{ fontWeight: 600 }}>
                {date}
            </Typography>
            <Typography variant='body2'>{statusText}</Typography>
            {(inTime || outTime) && (
                <Typography variant='body2'>
                    In: {inTime ? formatTime(inTime) : '-- --'} · Out:{' '}
                    {outTime ? formatTime(outTime) : '-- --'}
                </Typography>
            )}
            {duration > 0 && (
                <Typography variant='body2'>
                    Total: {calculateSecondsToHoursAndMinutes(duration)} h
                </Typography>
            )}
            {extras.length > 0 && (
                <Typography variant='body2' sx={{ opacity: 0.8 }}>
                    Also: {extras.map((key) => statusLabel(key)).join(' · ')}
                </Typography>
            )}
        </Box>
    );
};

export { DayTooltipContent as default, DayTooltipContent };
